
const state = {
  loginPopupState: false,
  alarmPopupState: false,
  menuState: false
}

const getters = {
  loginPopupState () {
    return state.loginPopupState
  },
  alarmPopupState () {
    return state.alarmPopupState
  },
  menuState () {
    return state.menuState
  }
}

const actions = {}

const mutations = {
  showLoginPopup (state) {
    state.loginPopupState = true
  },
  hideLoginPopup (state) {
    state.loginPopupState = false
  },
  showAlarmPopup (state) {
    state.alarmPopupState = true
  },
  hideAlarmPopup (state) {
    state.alarmPopupState = false
  },
  showMenu (state) {
    state.menuState = true
  },
  hideMenu (state) {
    state.menuState = false
  }
}

export default { state, getters, actions, mutations }
